import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const H3 = ({ tag: Tag = "h3", children, className, ...rest }) => (
  <Tag
    className={classNames(
      "m-0",
      "text-2xl",
      "font-semibold",
      "line-height-130",
      "text-black",
      "md:text-2xl.1",
      "md:font-bold",
      "md:line-height-100",
      className
    )}
    {...rest}
  >
    {children}
  </Tag>
);

H3.propTypes = {
  tag: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default H3;
